import { InviteFreeGroupUserPage } from './InviteFreeGroupUserPage';
export default InviteFreeGroupUserPage;
